<template>
  <div id="container">
    <div class="box_one" > 
      <cont-top/>
    </div>     
    <div class="main" style="margin-bottom:5px"> 

      <div class="title">
        <div class="title_name"></div>
      </div>

      <div class="clear" style="padding: 0 40px">
        <div style="margin-bottom:20px;text-indent:32px">
          DIXCEL中国“迪库盛贸易（上海）有限公司”于2011年8月在上海成立。
        </div>

        <div style="margin-bottom:20px;text-indent:32px">
          作为DJ HOLDINGS集团公司旗下的全资子公司，DIXCEL中国不仅将日本高性能刹车片、碟、油、卡钳等带进中国，更是迎合中国市场的特殊需求，在中国特有车型调查、产品开发、性能测试、客户服务等方面展示出了子公司的优越性。产品线的丰富、库存的完备、专业的客服对应使得DIXCEL在中国迅速成为热卖品牌，深得广大经销商与终端车主的喜爱。
        </div>

        <div style="margin-bottom:20px;text-indent:32px">
          不仅在民用市场，在赛车运动中DIXCEL中国也取得了巨大成就。CTCC中国房车锦标赛、大众尚酷R杯、大众POLO杯、CHINAGT、CEC等赛事、车队都能看到DIXCEL的身影。通过参与高级别赛事，了解客户需求、分析产品性能，从而更好地为广大车主服务。
        </div>

        <div style="margin-bottom:20px;text-indent:32px">
          从2011年起，DIXCEL中国就开始积极参与China Auto Salon（CAS）、GTSHOW、ALL IN TUNING等国内知名展会，通过展会积极与各地经销商、终端车主进行沟通、了解客户诉求，因地制宜地制定经营销售政策，以满足不同区域不同客户的诉求。
        </div>

        <div style="margin-bottom:50px;text-indent:32px">
          DIXCEL中国也秉承了DIXCEL日本“让客户满意，让员工满意”的经营理念，客户满意的同时也是对员工最大的肯定，这也促使着我们向客户提供更为优质的服务。
        </div>

        <div style="text-align:center">
          <el-image
            style="width:755px; margin-bottom:20px;"
            :src="require('@/assets/image/brand/BrandCn/img6.png')"
            fit="fit">
          </el-image>
        </div>



      </div>

    </div>    
    <div class="box_bottom" > 
      <cont-bottom/>
    </div>
  </div>
</template>

<script>
import ContTop from './Cont_top'
import ContBottom from '@/views/Components/Cont_bottom'


export default {
  data() {
    return {
      fit : 'contain'
    }
  },
  components : {
    ContTop ,
    ContBottom ,
  }
}

</script>

<style lang="stylus" scoped>
.clear:after {
  display: block;
  clear: both;
  content: '';
}

#container
  background-color : #000
  .box_one 
    width: 100%;
    // background: url("~@/assets/image/brand/img1.png");
    background-repeat : no-repeat 
    background-size : cover
    background-color #000

  .box_bottom
    width: 100%;
    background-color #000


.main {
  margin-bottom: 5px;
  width: 1003px;
  background-color: #fff;
  margin: 0 auto;
  position: relative;
  box-sizing: border-box;
  padding: 55px 0 44px
}

.title {
  position: absolute;
  width: 170px;
  height: 108px;
  left: 66px;
  top: -68px;
  background: url('~@/assets/image/brand/BrandCn/img1.png');
  background-repeat: no-repeat;
  background-size: cover;
  padding: 33px 33px 16px 40px; 
  box-sizing: border-box;
}

.title_name {
  width: 97px;
  height: 59px;
  background: url('~@/assets/image/brand/BrandCn/img2.png');
  background-repeat: no-repeat;
  background-size: contain;
}

</style>